export default "__VITE_ASSET__x9S7VvrQ__"